module.exports = __webpack_public_path__ + "img/dsg_career_portal.7d165362.png";